import { Component, Input } from '@angular/core';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
@Component({
    selector: 'app-excel-download',
    imports: [],
    template: `<div
    class="flex justify-center items-center"
    (click)="downloadExcel()"
  >
    <img src="../../../../assets/svg/downloadreport.svg" alt="arrow" />
  </div>`
})
export class ExcelDownloadComponent<T extends Record<string, any>> {
  @Input() columns!: Array<{ header: string; field: string; sequence: number }>;
  @Input() apiResponse!: T[]; 
  @Input() headerStyling: { [key: string]: any } = {}; 
  @Input() fileName: string = 'download.xlsx'; 
  @Input() sheetName: string = 'Sheet1';

  async downloadExcel() {
    const sortedColumns = this.columns.sort((a, b) => a.sequence - b.sequence);
    const headers = sortedColumns.map((col) => col.header);
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(this.sheetName || 'Sheet1');
    worksheet.addRow(headers);
    this.apiResponse?.forEach((item) => {
      const row = sortedColumns.map((col) => item[col.field]);
      worksheet.addRow(row);
    });

    if (this.headerStyling && worksheet.getRow(1)) {
      worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true };
        if (this.headerStyling['font']) {
          cell.font = { ...cell.font, ...this.headerStyling['font'] };
        }
        if (this.headerStyling['fill']) {
          cell.fill = this.headerStyling['fill'];
        }
        if (this.headerStyling['alignment']) {
          cell.alignment = this.headerStyling['alignment'];
        }
      });
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(blob, this.fileName);
  }
}
